import { createTheme, ThemeOptions, PaletteMode } from '@mui/material/styles';
import { DEFAULT_THEME_FONT_ID, themeFontFamilyCss } from '@/theme/fontCatalog';

/** Default sage green accent (light and dark) when no custom accent is stored. */
export const DEFAULT_ACCENT_COLOR = '#5f8f72';

export const COLORS = {
  primary: DEFAULT_ACCENT_COLOR,
  primaryHover: '#4a7a5c',
  secondary: '#dc004e',
  error: '#f44336',
};

const getThemeOptions = (
  mode: PaletteMode,
  fontFamily: string,
  primaryMain: string,
): ThemeOptions => ({
  palette: {
    mode,
    primary: {
      main: primaryMain,
    },
    secondary: {
      main: COLORS.secondary,
    },
  },
  typography: {
    fontFamily,
    h1: {
      fontSize: '2.5rem',
      fontWeight: 600,
    },
    h2: {
      fontSize: '2rem',
      fontWeight: 500,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
        },
      },
    },
  },
});

export const getTheme = (
  mode: PaletteMode,
  fontFamily: string,
  primaryMain: string = DEFAULT_ACCENT_COLOR,
) => createTheme(getThemeOptions(mode, fontFamily, primaryMain));

const themeConfig = createTheme(
  getThemeOptions('light', themeFontFamilyCss(DEFAULT_THEME_FONT_ID), DEFAULT_ACCENT_COLOR),
);
export default themeConfig;